import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

/**** Components ****/
import Login from "../pages/auth/Login";

const ProtectedRoute = ({ children }) => {

    const { isAuthenticated, isLoggedIn } = useSelector((state) => state.auth);

    return (isAuthenticated && isLoggedIn) ? children : <Login />;
}

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ProtectedRoute;